import React from 'react'
import { useLocation } from 'react-router'
import { ContentHeader } from '../../../components/Header/ContentHeader'
import { ICustomizedLocationState } from '../../../types/customLocation'


const TimeTrackingInvolvedTasksHeaderContainer = (): JSX.Element => {
  const _location = useLocation()
  const _locationState = _location.state as ICustomizedLocationState

  return (
    <ContentHeader
      title='Time Tracking - Involved Tasks'
      backTitle='Time Tracking'
      color='#232C58'
      backLocation={_locationState.from === 'time-tracking' ? '/time-tracking' : '/user-dashboard'}
    />
  )
}

export default TimeTrackingInvolvedTasksHeaderContainer
